window.MassPayment = {

    applyToAll: function (me) {

        var valToApply = me.closest('.form-group').find('.toApply').val();
        var fromApply = me.closest('.form-group').find('.toApply').attr('toApply');
        var toApply = fromApply + "_toApply";

        $('.onePaymentToAdd').not('.processed').find('.' + toApply).val(valToApply);

    },

    processQueuePayments: function (skipFailed) {

        var skipFailed = skipFailed === undefined ? false : skipFailed;

        if ($('.massPaymentFormbtn').hasClass('btn-success')) {
            $('.massPaymentFormbtn').removeClass('btn-success').addClass('btn-default').attr('disabled', 'disabled');
        }

        if (skipFailed) {
            var formToProcess = $('.onePaymentToAdd').not('.processed').not('.processfailed').first().find('form').attr('id');
        } else {
            var formToProcess = $('.onePaymentToAdd').not('.processed').first().find('form').attr('id');
        }

        MassPayment.processOneQueuedPayment(formToProcess);

        if (formToProcess == undefined) {
            $('.massPaymentFormbtn').addClass('btn-success').removeClass('btn-default');
            $('.massPaymentFormbtn').removeAttr('disabled');
            if ($('.processfailed').length == 0) {
                $('.massPaymentFormbtn').remove();
            }
        }
    },

    processOneQueuedPayment: function (formId) {

        $("#" + formId).closest('.row').removeClass('processfailed').addClass('processing');

        if ($("#" + formId).position() != undefined) {
            $('#popupWindow').scrollTop($("#" + formId).position().top);
        }


        var options = {
            success: function (data) {
                var formIsOk = MyForm.processJson(data, formId);

                if (formIsOk) {
                    $("#" + formId).closest('.row').removeClass('processing').addClass('processed');
                } else {
                    $("#" + formId).closest('.row').removeClass('processing').addClass('processfailed');
                }

                MassPayment.processQueuePayments(true);
            },
            dataType: "json",
            data: { action: "recordOnePaymentFormMassForm", formId: formId }
        };

        MyForm.prepare(formId, "payment", options, false);

        $('#' + formId).submit();

    },

    massPaymentForm: function (rowSelection, listingPrefix) {

        var title = Loc.g("Enregistrer des paiements en masse");
        var options = {
            title: title,
            width: 1250,
            close: function () {
                listingName = 'docinvoicesListing';
                if (listingPrefix == 'pur') {
                    listingName = 'purdocinvoicesListing';
                }
                Utils.reload();
            },
            buttons: [
                {
                    text: Loc.g("Fermer"),
                    'class': 'btn btn-default',
                    click: function () {
                        $(this).dialog("close");
                    }
                },
                {
                    text: Loc.g("Enregistrer les paiements"),
                    'class': 'btn btn-primary massPaymentFormbtn',
                    click: function () {
                        MassPayment.processQueuePayments();
                    }
                }
            ],
            callback: function () {
                MyFacture.customForm();
            }
        };

        MyWindow.load("payment", {
            action: "massPaymentForm",
            rowSelection: rowSelection,
            listingPrefix: listingPrefix
        }, options);

    },

    massSetAsConfirmed: function (rowSelection) {

        var options = {
            resizable: false,
            noclose: true,
            title: Loc.g("Changement d‘état"),
            type: "warning",
            buttons: [
                {
                    text:
                        Loc.g("Oui"),
                    click: function () {
                        var datas = {
                            action: "massSetAsConfirmed",
                            rowSelection: rowSelection
                        };
                        MyFacture.post("payment", datas, function (data) {
                            Listing.update('paymentsListing');
                        }, "json");
                        $(this).dialog("close");
                    }
                },
                {
                    text: Loc.g("Non"), click: function () {
                        $(this).dialog("close");
                    }
                }
            ]
        };

        MyWindow.alert(Loc.g("Voulez-vous confirmer ces paiements ?"), options);

    }

};


window.Payment = {

    setAsConfirmed: function (payID, action) {
        var options = {
            resizable: false,
            noclose: true,
            title: Loc.g("Changement d‘état"),
            type: "warning",
            buttons: [
                {
                    text:
                        Loc.g("Oui"),
                    click: function () {
                        var datas = {
                            action: "setAsConfirmed",
                            payID: payID
                        };
                        MyFacture.post("payment", datas, function (data) {

                            if (action === 'reload') {
                                DocOverview.loadLinkedTab($('#doctype').val(), $('#docid').val());
                            } else {
                                Listing.update('paymentsListing');
                            }

                        }, "json");
                        $(this).dialog("close");
                    }
                },
                {
                    text: Loc.g("Non"), click: function () {
                        $(this).dialog("close");
                    }
                }
            ]
        };

        MyWindow.alert(Loc.g("Voulez-vous confirmer ce paiement ?"), options);
    },

    edit: function (payID, thirdid) {
        var formId = "paymentForm";

        payID = payID === undefined ? '' : payID;

        var options = {
            title: Loc.g('Ajouter un règlement'),
            buttons:
                [
                    {
                        text: Loc.g("Annuler"), click: function () {
                            $(this).dialog("close");
                        }
                    },
                    {
                        text: Loc.g("Enregistrer"), click: function () {
                            $("#" + formId).submit();
                        }
                    }
                ],
            width: 800,
            callback: function () {
                var options = {
                    success: function (data) {
                        var formIsOk = MyForm.processJson(data, formId);
                        if (formIsOk) {
                            MyWindow.close();
                            Listing.update('paymentsListing', true);
                            if (!Utils.exists('paymentsListing_container')) {
                                MyWindow.alert(Loc.g("Le paiement a bien été enregistré"), { type: 'confirm' });
                            }
                        }
                    },
                    dataType: "json",
                    data: { action: "recordPayment" }
                };

                MyForm.prepare(formId, "payment", options, true);

                $('input[name=pay_type]').unbind('change').bind('change', function () {
                    if ($(this).val() === 'credit') {
                        $('.bankDeposit').find('legend').html(Loc.g('Remise en banque'));
                        $('.bankDeposit').find('label[for=pay_inBank] span').html(Loc.g('Ce règlement a été mis en banque'));
                    } else {
                        $('.bankDeposit').find('legend').html(Loc.g('Constaté en banque'));
                        $('.bankDeposit').find('label[for=pay_inBank] span').html(Loc.g('Ce règlement a été constaté en banque'));
                    }
                    MyFacture.customForm();
                });


                $('input[name=pay_inBank]').unbind('change').bind('change', function () {
                    if ($(this).is(':checked')) {
                        $('.bankDetails:hidden').slideDown('fast');
                        MyFacture.customForm('.bankDetails');
                    } else {
                        $('.bankDetails:visible').slideUp('fast');
                    }
                });
                $('input[name=pay_inBank]').trigger('change');

                $('input#pay_amount').bind('change', function () {
                    var dataNF = $('#pay_numformat');
                    var numformat = {
                        'name': dataNF.find('#numpay_name').val(),
                        'currency': dataNF.find('#numpay_currency').val(),
                        'decimals': dataNF.find('#numpay_decimals').val(),
                        'thousands': dataNF.find('#numpay_thousands').val(),
                        'currencypos': dataNF.find('#numpay_currencypos').val(),
                        'precision': dataNF.find('#numpay_precision').val()
                    };
                    $(this).val(NumberFormat.formatToDisplay($(this).val(), numformat));
                });
                $('input#pay_amount').trigger('change');

                MyFacture.customForm();
            }
        };

        MyWindow.load("payment", { action: "editForm", payid: payID, thirdid: thirdid }, options);
    },


    showLinked: function (payID) {
        var options = {
            title: Loc.g('Documents liés'),
            buttons:
                [
                    {
                        text: Loc.g("Fermer"), click: function () {
                            $(this).dialog("close");
                        }
                    }
                ],
            width: 600
        };

        MyWindow.load("payment", { action: "showLinked", payID: payID }, options);
    },


    /***        PAYMENTS        ***/
    editPayment: function (payID) {

        payID = undefined === payID ? "" : payID;

        var formId = "docPaymentForm";

        var options = {
            title: Loc.g('Paiement'),
            buttons: [
                {
                    text: Loc.g("Annuler"),
                    'class': 'btn btn-default',
                    click: function () {
                        $(this).dialog("close");
                    }
                },
                {
                    text: Loc.g("Enregistrer"),
                    'class': 'btn btn-primary',
                    click: function () {
                        $("#" + formId).submit();
                    }
                }
            ],
            width: 600,
            callback: function () {

                var params = { action: 'updatePayment' };

                var options = {
                    success: function (data) {
                        var formIsOk = MyForm.processJson(data, "docPaymentForm");
                        if (formIsOk) {
                            Utils.reload();
                            MyWindow.close();
                        }
                    },
                    dataType: "json",
                    data: params
                };

                MyForm.prepare(formId, "payment", options, true);
                MyFacture.customForm();
            }
        };

        var fileOpt = { action: "paymentForm", payid: payID };
        MyWindow.load("payment", fileOpt, options);

    },

    deleteIt: function (payID) {
        var options = {
            resizable: false,
            noclose: true,
            title: Loc.g("Suppression d'un paiement"),
            type: "warning",
            dialogClass: 'white',
            buttons: [
                {
                    text: Loc.g("Annuler"), click: function () {
                        $(this).dialog("close");
                    }
                },
                {
                    text:
                        Loc.g("Supprimer"),
                    click: function () {
                        var datas = {
                            action: "delete",
                            payID: payID
                        };
                        MyFacture.post("payment", datas, function (data) {
                            window.paymentListingName = ($('#thirdid').length > 0 ? 'third' : '') + 'paymentsListing';
                            Listing.update(paymentListingName);
                        }, "json");
                        $(this).dialog("close");
                    }
                }

            ]
        };

        MyWindow.alert(Loc.g("Voulez-vous supprimer le paiement ?"), options);
    },


    prepareFilterForm: function () {
        var filterForm = 'paymentsFilterForm';

        var options = {
            success: function (data) {
                Payment.processFilterForm(data);
            }, dataType: "json"
        };

        MyForm.prepare(filterForm, "invoices", options);

        if ($('#paymentsListing_container').hasClass('linkingListing')) {
            Listing.freezeFilters(filterForm);
        }

        MyForm.prepare(filterForm, "payments&action=updateListing", options);
        Payment.initTips();
    },


    processFilterForm: function (data) {
        Listing.refresh(data.listingName, data, eval('data.' + data.metadatasName));
        Payment.initTips();
    },


    deleteRelated: function (payrelid) {
        var options = {
            resizable: false,
            noclose: true,
            title: Loc.g("Suppression d'un paiement"),
            type: "warning",
            dialogClass: 'white',
            buttons: [
                {
                    text: Loc.g("Annuler"), click: function () {
                        $(this).dialog("close");
                    }
                },
                {
                    text:
                        Loc.g("Supprimer"),
                    click: function () {
                        var datas = {
                            action: "deleteRelated",
                            payrelid: payrelid
                        };

                        MyFacture.post("payment", datas, function (data) {
                            Listing.update('paymentsListing');
                            MyWindow.close();
                        }, "json");
                        $(this).dialog("close");
                    }
                }
            ]
        };

        MyWindow.alert(Loc.g("Voulez-vous supprimer le paiement du document ?") + "\n" + Loc.g("Cette suppression impactera le statut du document."), options);
    },


    massBankDeposit: function (listingObject, rowSelection) {
        var payIds = [];
        var regexp = new RegExp('');

        var debit = false;
        var credit = false;

        for (var i in rowSelection) {
            payIds.push(rowSelection[i].toString().replace('payments_', ''));

            if ($('#' + rowSelection[i].toString()).hasClass('payment-debit')) {
                debit = true;
            }
            if ($('#' + rowSelection[i].toString()).hasClass('payment-credit')) {
                credit = true;
            }
        }

        if (debit && credit) {
            MyWindow.alert(Loc.g("Vous ne pouvez effectuer de remise en banque qu'avec plusieurs débits ou plusieurs crédits"), { type: 'error' });
            return;
        }

        var formId = "bankDepositForm";

        var options = {
            title: Loc.g('Remise en banque'),
            buttons:
                [
                    {
                        text: Loc.g("Annuler"), click: function () {
                            $(this).dialog("close");
                        }
                    },
                    {
                        text: Loc.g("Enregistrer"), click: function () {
                            $("#" + formId).submit();
                        }
                    }
                ],
            width: 700,
            callback: function () {
                if ($('#' + formId + ' input[name=pbd_nbPayments]').val() === '0') {
                    MyWindow.addOption('buttons',
                        [
                            {
                                text: Loc.g("Fermer"), 'class': 'btn btn-default', click: function () {
                                    $(this).dialog("close");
                                }
                            }
                        ]);
                } else {
                    var options = {
                        success: function (data) {
                            var formIsOk = MyForm.processJson(data, formId);

                            if (formIsOk) {
                                MyWindow.close();
                                Listing.update('paymentsListing');
                            }
                        },
                        dataType: "json",
                        data: { action: "recordBankDeposit" }
                    };

                    MyForm.prepare(formId, "payment", options, true);
                    MyFacture.customForm();
                }
            }
        };

        MyWindow.load("payment", {
            action: "bankDepositForm",
            payIds: payIds,
            type: credit ? "credit" : "debit"
        }, options);
    },

    noBankDepositAllowed: function () {
        MyWindow.close();
        MyWindow.alert(Loc.g("Les paiements sélectionnés ont déjà été remis en banque."), { type: 'error' });
    },

    initTips: function () {
        var link = ['left', 'right', 'top', 'bottom'];
        var pos = ['leftMiddle', 'rightMiddle', 'topMiddle', 'bottomMiddle'];
        var curs = ['rightMiddle', 'leftMiddle', 'bottomMiddle', 'topMiddle'];


        var tipstypes = { 'color': '#468847', 'bg': '#dff0d8', 'border': '#d6e9c6' };

        $("[tip_type=nbdocs]").each(function () {
            var relatedId = $(this).attr('tip_relid');


            $(this).qtip({
                style: {
                    classes: 'custom-qtip rich-qtip',
                    def: false
                },
                position: {
                    viewport: true,
                    my: 'left center',
                    at: 'right center'
                },
                show: {
                    event: 'mouseover'
                },
                hide: {
                    event: 'mouseout',
                    fixed: true,
                    delay: 100
                },
                content: {
                    ajax: {
                        url: '/?_f=payment',
                        type: 'GET',
                        data: {
                            action: 'qtipLinked',
                            payid: relatedId
                        },
                        once: true
                    }
                }
            });
        });
    }
};


window.PaymentLinkInList = {

    prepareLinkForm: function (formId) {
        var options = {
            beforeSend: function () {
                MyFacture.startWait();
            },
            success: function (data) {
                var formIsOk = MyForm.processJson(data, formId);
                MyFacture.stopWait();
                if (!formIsOk && data.form.msg !== '') {
                    MyWindow.alert(data.form.msg, { type: 'error' });
                } else if (data.redirect !== undefined) {
                    Utils.relocate(data.redirect);
                }
            },
            dataType: "json"
        };

        var action = $('#' + formId).find('input[name=action]').val();

        var params = { action: action };
        MyForm.prepare(formId, "payment&" + $.param(params), options);

        if ($('.linkedContainer li:not(.template)').length > 0) {
            $("#submitLink").show();
            $(".placeholder").hide();
        } else {
            $(".placeholder").show();
            $("#submitLink").hide();
        }

    },

    init: function (doctype) {

        PaymentLinkInList.prepareLinkForm("linkinlistForm");

        var $linkForm = $('#linkinlistForm');
        var numberFormat = NumberFormat.load(null, 'num_');
        var action = $linkForm.find('input[name=action]').val();

        switch (action) {
            case "linkToPayment":

                $(document).off('change', '.listing tbody tr input:checkbox').on('change', '.listing tbody tr input:checkbox', function (e) {

                    var actionCheck = $(this);

                    var paymentToLink = $('#payment_toLink').val();
                    if (paymentToLink == '') {
                        paymentToLink = '0';
                    }

                    if (!actionCheck.is(':checked')) {
                        actionCheck.prop('checked', false);
                        $('#linked-pay-' + actionCheck.attr('id')).remove();

                    } else {
                        actionCheck.prop('checked', true);

                        var $linked = $('.linked.template', $linkForm).clone();
                        var payID = actionCheck.attr('id');


                        $linked.removeClass('template');
                        $linked.attr('id', 'linked-pay-' + payID);

                        $linked.find('.pay_id')
                            .attr('name', 'link_pay[' + payID + '][id]')
                            .attr('id', 'link_pay[' + payID + '][id]')
                            .val(payID);

                        var toLink = parseFloat(paymentToLink);
                        var remaining = parseFloat(actionCheck.attr('link-remaining'));
                        if (toLink > remaining) {
                            toLink = remaining;
                        }

                        $linked.find('.pay_amount')
                            .attr('name', 'link_pay[' + payID + '][amount]')
                            .attr('id', 'link_pay_' + payID + '_amount')
                            .val(toLink);

                        $linked.find('.pay_remaining')
                            .attr('name', 'link_pay[' + payID + '][remaining]')
                            .attr('id', 'link_pay_' + payID + '_amountRemaining')
                            .val(actionCheck.attr("link-remaining"));

                        $linked.find('.linked-date').html(actionCheck.attr('link-date'));
                        $linked.find('.linked-amount').html(NumberFormat.formatToDisplayWithCurrency(actionCheck.attr('link-amount'), numberFormat));
                        $linked.find('.linked-remaining').html(actionCheck.attr('link-remaining'));

                        $linked.appendTo('.linkedContainer').show();
                        MyFacture.customForm('#linked-pay-' + actionCheck.attr('id'));

                        $('[name="link_pay[' + payID + '][amount]"]').keyup(function () {
                            PaymentLinkInList.updateAmount(paymentToLink, $linkForm);
                        });
                    }

                    PaymentLinkInList.updateAmount(paymentToLink, $linkForm);

                    if ($('.linkedContainer li:not(.template)').length > 0) {
                        $("#submitLink").show();
                        $(".placeholder").hide();
                    } else {
                        $(".placeholder").show();
                        $("#submitLink").hide();
                    }


                    e.stopPropagation();
                    e.preventDefault();

                });


                break;
            case 'linkToRelated':

                $(document).off('change', '.listing tbody tr input:checkbox').on('change', '.listing tbody tr input:checkbox', function (e) {


                    var actionCheck = $(this);
                    $('input[name=link_relatedtype]').val(actionCheck.data('relatedtype'));

                    var paymentTotal = $('#payment_total').val();
                    if (paymentTotal == '') {
                        paymentTotal = '0';
                    }

                    var deadlines = undefined;
                    if ($(this).closest('tr').find('input[name=jsondeadlines]').length > 0) {
                        deadlines = JSON.parse($(this).closest('tr').find('input[name=jsondeadlines]').val());
                    }

                    if (!actionCheck.is(':checked')) {
                        actionCheck.prop('checked', false);
                        $('#linked-related-' + actionCheck.attr('id')).remove();

                    } else {


                        actionCheck.attr('checked', true);

                        var $linked = $('.linked.template', $linkForm).clone();
                        var relatedID = actionCheck.attr('id');

                        $linked.removeClass('template');
                        $linked.attr('id', 'linked-related-' + relatedID);

                        var toLink = parseFloat($('#payment_total').val(), 10);
                        var remaining = parseFloat(actionCheck.data('due'), 10);
                        if (toLink < remaining) {
                            remaining = toLink;
                        }


                        $linked.find('.link_relatedid')
                            .attr('name', 'link_related[' + relatedID + '][id]')
                            .attr('id', 'link_related_' + relatedID + '_id')
                            .val(relatedID);

                        $linked.find('.link_relatedtype')
                            .attr('name', 'link_related[' + relatedID + '][type]')
                            .attr('id', 'link_related_' + relatedID + '_type')
                            .val(0);

                        $linked.find('.link_relatedamount')
                            .attr('name', 'link_related[' + relatedID + '][amount]')
                            .attr('id', 'link_related_' + relatedID + '_amount')
                            .attr('e_formatmax', paymentTotal)
                            .val(remaining);

                        $linked.find('.link_due')
                            .attr('name', 'link_related[' + relatedID + '][remaining]')
                            .attr('id', 'link_related[' + relatedID + ']_remaining')
                            .val(remaining);


                        $linked.find('.linked-ident').html(actionCheck.attr('link-ident'));
                        $linked.find('.linked-due').html(
                            NumberFormat.formatToDisplayWithCurrency(parseFloat(actionCheck.data('due'), 10), numberFormat)
                        );
                        $linked.find('.link_relatedamount').html(actionCheck.attr('link-due'));

                        if (deadlines != undefined) {

                            for (var cpt in deadlines) {

                                if (deadlines[cpt].remainingAmount > 0) {

                                    var $deadline = $('<li class="deadline"></li>');
                                    $deadline.append('<label class="">'
                                        + '<input type="checkbox" name="link_related[' + relatedID + '][deadlineid][]" value="' + deadlines[cpt].id + '" remaining="' + deadlines[cpt].remainingAmount + '" />'
                                        + deadlines[cpt].amount_formatted_withCurrency
                                        + ' ' + Loc.g('dû au') + " " + deadlines[cpt].date_formatted
                                        + ' : <span class="' + deadlines[cpt].step_formatted.css + '">' + deadlines[cpt].remainingAmount_formatted_withCurrency + ' ' + Loc.g('à solder') + '</span>'
                                        + (deadlines[cpt].late == 'Y' ? ' <span class="error">' + Loc.g('En retard') + '</span>' : '')
                                        + '</label>');

                                    $deadline.appendTo($linked.find('.deadlines'));

                                }
                            }
                            $linked.append('<input type="hidden" name="link_related[' + relatedID + '][hasDeadlines]" value="Y"  />');
                        } else {
                            $linked.append('<input type="hidden" name="link_related[' + relatedID + '][hasDeadlines]" value="N"  />');
                        }

                        $linked.appendTo('.linkedContainer').show();


                        MyFacture.customForm('#linked-related-' + relatedID);

                        if (deadlines != undefined) {
                            $('#linked-related-' + relatedID + ' .info-deadlines').show();
                        } else {
                            $('#linked-related-' + relatedID + ' .info-deadlines').hide();
                        }

                        $('#linked-related-' + relatedID + ' .deadlines input[type=checkbox]').unbind('click').bind('click', function () {

                            var totalAmount = Big(0);

                            $('#linked-related-' + relatedID + ' .deadlines input[type=checkbox]').each(function () {

                                if ($(this).is(':checked')) {
                                    var deadlineAmount = parseFloat($(this).attr('remaining'), 10);
                                    totalAmount = totalAmount.plus(new Big(deadlineAmount));
                                }

                            });

                            if (remaining > totalAmount.toString()) {
                                $('#link_related_' + relatedID + '_amount').val(totalAmount.toString());
                            } else {
                                $('#link_related_' + relatedID + '_amount').val(remaining);
                            }

                            $('#link_related_' + relatedID + '_amount').trigger('change');
                            PaymentLinkInList.updateAmount(paymentTotal, $linkForm);

                        });

                        $('[name="link_related[' + relatedID + '][amount]"]').keyup(function () {
                            PaymentLinkInList.updateAmount(paymentTotal, $linkForm);
                        });


                    }

                    PaymentLinkInList.updateAmount(paymentTotal, $linkForm);

                    if ($('.linkedContainer li:not(.template)').length > 0) {
                        $("#submitLink").show();
                        $(".placeholder").hide();
                    } else {
                        $(".placeholder").show();
                        $("#submitLink").hide();
                    }
                    e.stopPropagation();
                    e.preventDefault();
                    return false;

                });
                break;
        }

        $(document).off('click', '.listing tbody tr td:not(.groupedActionCheckerContainer)').on('click', '.listing tbody tr td:not(.groupedActionCheckerContainer)', function () {

            var checker = $(this).closest('tr').find('input:checkbox');
            checker.prop('checked', !checker.prop('checked'));
            checker.trigger('change');
        });
    },

    updateAmount: function (paymentToLink, $form) {
        if ($('[id^="docnum_"]').length > 0) {
            var numberFormat = NumberFormat.loadFromInputs('docnum_');
        } else if ($('[id^="num_"]').length > 0) {
            var numberFormat = NumberFormat.loadFromInputs('num_');
        } else {
            var numberFormat = NumberFormat.load(null, 'num_');
        }

        var dueAmount = new Big(paymentToLink);
        var totalLinked = 0;

        $.each($('.linkedContainer .linked:visible'), function () {
            var amount = $(this).find('.pay_amount').length > 0 ? $(this).find('.pay_amount').val() : $(this).find('.link_relatedamount').val();

            amount = NumberFormat.formatToFloat(amount, numberFormat);
            totalLinked = totalLinked + amount;
            dueAmount = dueAmount.minus(amount);
        });

        var dueAmountSelector = $form.find('.dueAmount .info-value, .remainingAmount .info-value');
        var submit = $form.find('input[type=submit]');

        var isLinkable = (dueAmount >= 0 && totalLinked > 0);

        const linkRelatedType = $('#link_relatedtype').val() ?? null;
        if (
			linkRelatedType === null ||
            ['order', 'estimate', 'delivery', 'proforma'].indexOf(linkRelatedType) < 0
        ) {
            dueAmountSelector.html(NumberFormat.formatToDisplayWithCurrency(dueAmount, numberFormat, true));
            dueAmountSelector.toggleClass('red', !isLinkable);
        }

        submit.toggleClass('btn-primary', isLinkable).toggleClass('disabled', !isLinkable);

        if (!isLinkable && submit.attr('disabled') !== 'disabled') {
            submit.attr('disabled', 'disabled');
        } else if (isLinkable && submit.attr('disabled') == 'disabled') {
            submit.removeAttr('disabled');
        }
    }
};

window.BankDeposit = {

    view: function (bdid) {

        var options = {
            title: Loc.g('Détail remise en banque'),
            buttons: [
                {
                    'text': Loc.g("Imprimer"), click: function () {
                        window.location.href = '?_f=bankDeposits&action=download&bdid=' + bdid
                    }
                }
            ]
        };

        MyWindow.load('bankDeposits', { action: 'view', bdid: bdid }, options);
    },

    prepareFilterForm: function () {
        var options = {
            success: function (data) {
                BankDeposit.processFilterForm(data);
            }, dataType: "json"
        };

        MyForm.prepare("bankDepositsFilterForm", "bankDeposits&action=updateListing", options);
    },

    processFilterForm: function (data) {
        Listing.refresh(data.listingName, data, eval('data.' + data.metadatasName));
    },


    deleteIt: function (bankDepositId, force) {
        force = undefined === force ? false : force;

        var title = '';
        var message = '';
        if (force) {
            title = Loc.g("Forcer la suppression d'une remise en banque");
            message = Loc.g("Voulez-vous forcer la suppression de la remise en banque ?") + "<br/>" + Loc.g("Cette suppression peut supprimer les écritures comptables si le module est activé.");
        } else {
            title = Loc.g("Suppression d'une remise en banque");
            message = Loc.g("Voulez-vous supprimer la remise en banque ?") + "<br/>" + Loc.g("Cette suppression supprimera les écritures comptables liées a cette remise en banque.");
        }

        var options = {
            resizable: false,
            noclose: true,
            title: title,
            type: 'warning',
            width: 500,
            buttons: [
                {
                    text:
                        Loc.g("Oui"),
                    click: function () {
                        var datas = {
                            action: "deleteBankDeposit",
                            bdid: bankDepositId,
                            force: force
                        };

                        MyFacture.post("bankDeposits", datas, function (data) {
                            if (data.status === 'ok') {
                                Listing.update('bankDepositsListing');
                                MyWindow.close();
                            } else {
                                MyWindow.close();
                                BankDeposit.deleteIt(bankDepositId, true);
                            }
                        }, "json");

                        $(this).dialog("close");
                    }
                },
                {
                    text: Loc.g("Non"), click: function () {
                        $(this).dialog("close");
                    }
                }
            ]
        };

        MyWindow.alert(message, options);
    }
};
